import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */
import html from "~/util/html.js";
import { modal } from "~/util/modal.js";
import Button from "~/component/Button.js";
/** @import { Props as ButtonProps } from "~/component/Button.js"; */

import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./ConfirmModal.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./ConfirmModal.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @param {object} options
 * @param {string | ComponentChildren} options.title
 * @param {ComponentChildren} options.body
 * @param {string} [options.action="Confirm"] Default is `"Confirm"`
 * @param {ButtonProps["kind"]} [options.kind="negative"] Default is `"negative"`
 * @returns {Promise<boolean | undefined>} True if confirmed, false if cancelled, undefined on
 *   dismissal
 */
export const confirmModal = ({
  title,
  body,
  action = "Confirm",
  kind = "negative"
}) => modal({
  title,
  content: (/** @type {(result?: boolean) => void} */resolve) => __h("div", {
    "class": css.modal
  }, body, __h("div", {
    "class": css.actions
  }, __h(Button, {
    level: "primary",
    kind: kind,
    onClick: () => resolve(true)
  }, action), __h(Button, {
    onClick: () => resolve(false)
  }, "Cancel")))
});